import { JCodeDocuments } from "../../../../../data-model/medicalPaOrdersModel";
import { DocumentTypesForOrder } from "../../../../../enums/documentTypes";
import { MedicalPaOrdersAuthStatus } from "../../../../../enums/medicalPaOrdersAuthStatus";

/**
 * Checks whether the `auth_letter` document has been uploaded
 * for a J-Code with `auth_on_file` authorization status.
 *
 * This utility is scoped narrowly:
 * - Only applies when `authStatus` is `"auth_on_file"`
 * - Only inspects documents of type `auth_letter`
 *
 * @param authStatus - Current authorization status of the J-Code.
 * @param docsFromDB - List of documents associated with the J-Code from the database.
 * @param jCodeId - The J-Code record identifier (unused in flag mode, kept for signature parity).
 * @param jCode - The J-Code value (unused in flag mode, kept for signature parity).
 *
 * @returns `true` if the auth letter document exists with a non-empty `doc_path`,
 *          `false` otherwise (including when the status is not `auth_on_file`).
 */
export const checkAuthLetterUploadStatus = (
  authStatus?: string,
  docsFromDB?: JCodeDocuments[],
): boolean => {
  if (authStatus !== MedicalPaOrdersAuthStatus.AuthOnFile) {
    return false;
  }

  const authLetterDoc = docsFromDB?.find(
    (d) =>
      d?.doc_type === DocumentTypesForOrder.AUTH_LETTER &&
      d?.doc_path &&
      d?.doc_path !== "",
  );

  return !!authLetterDoc?.doc_path;
};
